
/**
 * Configuration for native mobile features
 */

export const NATIVE_CONFIG = {
  // Deep linking configuration
  deepLink: {
    scheme: 'equiforge', // Default scheme for deep links
    callbackPath: '/auth/callback',
    homePath: '/'
  },
  
  // Default redirect URIs
  redirects: {
    auth: '/auth/callback',
    success: '/',
    error: '/login?error=true'
  }
};
